export default "__VITE_ASSET__C8Mnp_wl__"